import { ArrowBack as ArrowBackIcon } from "@mui/icons-material";
import { Box, IconButton, Typography } from "@mui/material";
import { DateRangePicker } from "@mui/x-date-pickers-pro/DateRangePicker";
import { FC } from "react";
import { useNavigate } from "react-router-dom";
import { useTradeMatcherDateRange } from "../hooks/useTradeMatcherDateRange";

export const TradeMatcherMenu: FC = () => {
  const navigate = useNavigate();
  const [range, setRange] = useTradeMatcherDateRange();

  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", marginRight: 2 }}>
        <IconButton
          onClick={() => navigate("/home")}
          sx={{ color: "secondary.main" }}
        >
          <ArrowBackIcon />
        </IconButton>
      </Box>
      <Typography variant="body1" component="span" sx={{ marginRight: 3 }}>
        Trade Matcher
      </Typography>
      <Box sx={{ width: 300 }}>
        <DateRangePicker
          defaultValue={range}
          onAccept={setRange}
          format="YYYY-MM-DD"
          localeText={{ start: "From", end: "To" }}
          slotProps={{ textField: { size: "small", fullWidth: true } }}
        />
      </Box>
    </>
  );
};
